// extracted by mini-css-extract-plugin
export default {"step":"Step_step__AIci2","overlay":"Step_overlay__DReWP"};